import { create } from 'zustand';

// --- Cells this viewer edited this session (SC-3113) ------------------------
//
// The "edited by you" marker on a table cell. SESSION-ONLY on purpose: no read
// path says which cells hold a person's edit today (neither `/table` rows nor
// the entity read carry per-cell provenance), so the marker can only remember
// what THIS browser did. The durable, server-sourced marker is SC-3407 (BE
// per-cell manual-edit provenance); when it lands, this store goes away rather
// than being reconciled with it.
//
// Each entry remembers the value written, and the marker only shows while the
// cell still holds it. If anyone changes the cell afterwards, the marker would
// be claiming someone else's value as ours, so it drops out on its own.
//
// Registered with `clearSessionState` (SC-2461): a marker must not survive into
// another user's session on the same browser.

/** `row_id` + field. NUL can't appear in either, so the key can't collide. */
export function editedCellKey(rowId: string, field: string): string {
  return `${rowId}\u0000${field}`;
}

interface CellEditState {
  /** catalogId → (editedCellKey → the value this viewer wrote). */
  byCatalog: Record<string, Record<string, string | null>>;
  markEdited: (catalogId: string, rowId: string, field: string, after: string | null) => void;
  reset: () => void;
}

export const useCellEditStore = create<CellEditState>((set) => ({
  byCatalog: {},
  markEdited: (catalogId, rowId, field, after) =>
    set((s) => ({
      byCatalog: {
        ...s.byCatalog,
        [catalogId]: { ...s.byCatalog[catalogId], [editedCellKey(rowId, field)]: after },
      },
    })),
  reset: () => set({ byCatalog: {} }),
}));
